export default __webpack_public_path__ + "static/media/0x7f280dac515121dcda3eac69eb4c13a52392cace.2a3b7e13.webp";